import { format } from 'date-fns';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { Text } from '../design/components/Typography';

export const CopyrightTenant: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return <Text color="secondary">{`© ${format(new Date(), 'yyyy')} ${translate('common.brand')}`}</Text>;
};
